import React from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Tooltip } from '@bringg/react-components';
import './icon-with-tooltip.scss';
import classNames from 'classnames';

interface IconWithTooltipProps {
	iconName: BringgFontIcons;
	title: string;
	color?: string;
	iconClassName?: string;
	id?: string;
}

const IconWithTooltip = ({
	iconName,
	color,
	title,
	iconClassName,
	id = 'icon-tooltip-container'
}: IconWithTooltipProps): JSX.Element => {
	return (
		<div className="icon-wrapper" id={id} data-test-id={iconName}>
			<Tooltip placement="top" title={title} getPopupContainer={() => document.getElementById(id)}>
				<BringgIcon
					className={classNames({ [iconClassName]: !!iconClassName })}
					color={color}
					iconName={iconName}
				/>
			</Tooltip>
		</div>
	);
};

export default IconWithTooltip;
